var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.12501 8.75L9.79168 10.4167L13.5417 6.66667M17.2917 17.5V6.5C17.2917 5.09987 17.2917 4.3998 17.0192 3.86502C16.7795 3.39462 16.3971 3.01217 15.9267 2.77248C15.3919 2.5 14.6918 2.5 13.2917 2.5H7.95834C6.55821 2.5 5.85815 2.5 5.32337 2.77248C4.85296 3.01217 4.47051 3.39462 4.23083 3.86502C3.95834 4.3998 3.95834 5.09987 3.95834 6.5V17.5L6.25001 15.8333L8.33334 17.5L10.625 15.8333L12.9167 17.5L15 15.8333L17.2917 17.5Z",
    stroke: "#6C737F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receipt-check.cb036c669e6130c440b1da927ffc167a.svg";
export { ForwardRef as ReactComponent };